import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { RxCross2 } from "react-icons/rx";

const Modal = ({ children, isOpen, closeModal, modalHeader, width }) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as='div' className='relative z-10' onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity' />
        </Transition.Child>

        <div className='fixed inset-0 z-10 overflow-y-auto '>
          <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <Dialog.Panel
                className='relative transform overflow-hidden rounded-xl bg-white shadow-xl transition-all dark:bg-[#170f2a] '
                style={{ width: width || "880px" }}
              >
                {modalHeader ? (
                  <div className='bg-white p-6 dark:bg-[#170f2a] dark:border-[#170f2a]'>
                    <div className='flex items-center justify-between'>
                      <Dialog.Title className='text-lg font-medium text-gray-900 dark:text-white'>
                        {modalHeader}
                      </Dialog.Title>
                      <button
                        type='button'
                        className='rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none dark:hover:bg-slate-800'
                        onClick={closeModal}
                      >
                        <RxCross2 className='h-5 w-5' />
                        <span className='sr-only'>Close</span>
                      </button>
                    </div>
                    <div className='mt-4 max-h-[calc(100vh-140px)] overflow-y-auto dark:text-white scroll-w-6'>
                      {children}
                    </div>
                  </div>
                ) : (
                  <div className='max-h-[calc(100vh-140px)] overflow-y-auto p-6 dark:text-white scroll-w-6'>
                    {children}
                    <button
                      type='button'
                      className='absolute right-4 top-4 rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none dark:hover:bg-slate-800'
                      onClick={closeModal}
                    >
                      <RxCross2 className='h-5 w-5 mr-4' />
                      <span className='sr-only'>Close</span>
                    </button>
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
